import { AbstractControl, ValidationErrors, ValidatorFn } from "@angular/forms";
import { MatDialogConfig } from "@angular/material/dialog";
import { environment } from "../../../../environments/environment";
import { InfoArquivo } from "../../chat/models/info-arquivo.model";
import { ArquivoMensagem } from "../../chat/models/arquivo-mensagem.model";
import {
  CLASSE_FONTE_CHAT, EXTENSAO_FIGURINHA, EXTENSOES_AUDIO, EXTENSOES_IMAGEM, EXTENSOES_VIDEO, INFO_ARQUIVO_APRESENTACAO, INFO_ARQUIVO_OUTRO,
  INFO_ARQUIVO_PDF, INFO_ARQUIVO_PLANILHA, INFO_ARQUIVO_TEXTO, ROTULOS_TIPO_PREVIA, TIPO_PREVIA_POR_TIPO_META, VELOCIDADES_MIDIA
} from "../../chat/utils/chat.constantes";
import { TipoPreviaMensagemEnum } from "../enum/tipo-previa-mensagem.enum";
import {DispositivosEnum} from '../enum/dispositivos.enum';
import { StatusContatoEnum } from "../enum/status-contato.enum";
import { Contato } from "../model/contato/contato.model";
import { SUFIXOS_ABREVIACAO_NUMERO } from "./numero.constantes";
import { MINUTOS_POR_HORA, MS_POR_MINUTO } from "./tempo.constantes";
import { AtendimentoLogModel } from "../model/atendimento/atendimento-log.model";
import { ROTULOS_LOG } from "../../chat/chat-conversa/modal-atendimento/utils/modal-atendimento.constantes";
export class MethodsUtils {
  private static readonly fotosPerfilIndisponiveis = new Set<string>();

  public static fotoPerfilDisponivel(url?: string | null): boolean {
    if (!url || MethodsUtils.fotosPerfilIndisponiveis.has(url)) return false;
    const expiracao = /[?&]oe=([0-9a-f]{1,16})(?:&|$)/i.exec(url);
    return !expiracao || parseInt(expiracao[1], 16) * 1000 > Date.now();
  }

  public static marcarFotoPerfilIndisponivel(url?: string | null): void {
    if (url) MethodsUtils.fotosPerfilIndisponiveis.add(url);
  }

  public static copiarEstadoAtendimento(destino: Contato, origem: Contato): void {
    destino.canal = origem.canal;
    destino.operador = origem.operador;
    destino.statusContato = origem.statusContato;
    destino.tranferenciaPendenteVisu = origem.tranferenciaPendenteVisu;
    destino.temSessaoAberta = origem.temSessaoAberta;
    destino.dataFechamentoSessao = origem.dataFechamentoSessao;
  }

  public static fotoPerfilContato(url: string | null | undefined, statusContato: StatusContatoEnum | undefined): string {
    return MethodsUtils.fotoPerfilDisponivel(url) ? url! : MethodsUtils.informacoesPorStatusContato(statusContato, true);
  }

  private static sanitizarDocumento(documento: string): string {
    return (documento ?? '').replace(/\D/g, '');
  }

  private static todosDigitosIguais(valor: string): boolean {
    return /^(\d)\1+$/.test(valor);
  }

  private static validarCPFNumerico(cpf: string): boolean {
    if (cpf.length !== 11 || this.todosDigitosIguais(cpf)) {
      return false;
    }

    let soma = 0;
    for (let i = 1; i <= 9; i++) {
      soma += parseInt(cpf.charAt(i - 1), 10) * (11 - i);
    }

    let resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) {
      resto = 0;
    }

    if (resto !== parseInt(cpf.charAt(9), 10)) {
      return false;
    }

    soma = 0;
    for (let i = 1; i <= 10; i++) {
      soma += parseInt(cpf.charAt(i - 1), 10) * (12 - i);
    }

    resto = (soma * 10) % 11;
    if (resto === 10 || resto === 11) {
      resto = 0;
    }

    return resto === parseInt(cpf.charAt(10), 10);
  }

  private static validarCNPJNumerico(cnpj: string): boolean {
    if (cnpj.length !== 14 || this.todosDigitosIguais(cnpj)) {
      return false;
    }

    const pesosPrimeiroDigito = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
    const pesosSegundoDigito = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

    let soma = 0;
    for (let i = 0; i < 12; i++) {
      soma += parseInt(cnpj.charAt(i), 10) * pesosPrimeiroDigito[i];
    }

    let resto = soma % 11;
    const primeiroDigito = resto < 2 ? 0 : 11 - resto;
    if (primeiroDigito !== parseInt(cnpj.charAt(12), 10)) {
      return false;
    }

    soma = 0;
    for (let i = 0; i < 13; i++) {
      soma += parseInt(cnpj.charAt(i), 10) * pesosSegundoDigito[i];
    }

    resto = soma % 11;
    const segundoDigito = resto < 2 ? 0 : 11 - resto;
    return segundoDigito === parseInt(cnpj.charAt(13), 10);
  }

  public static detectar_mobile() {
    let check = false; //wrapper no check
    (function(a){
      if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i
        .test(a.substr(0,4))) {
        check = true;
      }
    })(navigator.userAgent||navigator.vendor);
    return check;
  }

  public static detectar_dispositivos(): DispositivosEnum {
    const ua = navigator.userAgent || navigator.vendor || (window as any).opera;

    if (/iPad/i.test(ua) || /Macintosh/i.test(ua)) return DispositivosEnum.IPAD;
    if (/iPhone|iPod/i.test(ua)) return DispositivosEnum.MOBILE;

    if (/Android/i.test(ua)) {
      if (/Mobile/i.test(ua)) {
        return DispositivosEnum.MOBILE;
      } else {
        return DispositivosEnum.TABLET;
      }
    }

    if (/BlackBerry|IEMobile|Opera Mini/i.test(ua)) return DispositivosEnum.MOBILE;

    return DispositivosEnum.DESKTOP;
  }

  public static getPrefixoGrupoUrl(): string | boolean {
    const fullUrl: string = window.location.href;
    const prefixo: string = fullUrl.split("/")[3];

    if (prefixo == null || prefixo == '') {
      return false
    }else{
      return prefixo;
    }
  }

  public static resolucaoPolegadas(){
    const larguraJanela = window.innerWidth;
    const larguraPolegadas = larguraJanela / 96;
    return larguraPolegadas;
  }

  public static validarCPFControl(): ValidatorFn {
      return (control: AbstractControl): ValidationErrors | null => {
      const strCPF = control.value;
      if (!strCPF) {
        return null;
      }

      const sanitizedCPF = this.sanitizarDocumento(strCPF);
      if (sanitizedCPF.length !== 11 || this.todosDigitosIguais(sanitizedCPF) || !this.validarCPFNumerico(sanitizedCPF)) {
        return { invalidCPF: true };
      }

      return null;
    };
  }

  public static compareArrays(arr1: any[], arr2: any[]): boolean {
    return JSON.stringify(arr1).trim().includes(JSON.stringify(arr2).trim());
  }

  public static validarCPF(strCPF: string){
    const cpf = this.sanitizarDocumento(strCPF);
    return this.validarCPFNumerico(cpf);
  }

  public static validarCPFCNPJ(documento: string): boolean {
    const sanitizado = this.sanitizarDocumento(documento);
    if (sanitizado.length === 11) {
      return this.validarCPFNumerico(sanitizado);
    }

    if (sanitizado.length === 14) {
      return this.validarCNPJNumerico(sanitizado);
    }

    return false;
  }


  public static validarTelefone(strCelular: string):boolean{
    strCelular = strCelular.replace('(', '').replace(')', '').replace('-', '');
    if(strCelular.length < 10 || strCelular.length > 11){
      return false;
    }
    return true;
  }

  public static validarEmail(email: string): boolean {
    if (!email) {
      return false;
    }
    const re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/gi;
    return re.test(email);
  }

  public static getCorPrazo(progresso: number): string {
    if (progresso <= 25 && progresso >= 0) {
      return '#C60000';
    } else if (progresso <= 50) {
      return '#FF8A00';
    } else if (progresso <= 75) {
      return '#FFCE31';
    } else if (progresso <= 100 || progresso > 100) {
      return '#61B460';
    }else{
      return '#d4d4d4';
    }
  }

  public static ordenarAlfabeticamente(a: string, b: string): number {
    const nameA = a.toUpperCase();
    const nameB = b.toUpperCase();

    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  }


  public static formatarMensagemComNegritoItalicoRiscada(texto: string, isRemocaoDigitos: boolean): string{
    let formatado = texto
      .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;');

    if(!isRemocaoDigitos){
      // *texto* == texto como negrito
      formatado = formatado.replace(/\*([^*\n]+)\*/g, '<strong>$1</strong>');
      // _texto_ == texto como itálico
      formatado = formatado.replace(/_([^_\n]+)_/g, '<em>$1</em>');
      // ~texto~ == texto como riscado
      formatado = formatado.replace(/~([^~\n]+)~/g, '<s>$1</s>');
      return formatado
    }else{
      formatado = formatado
        .replace(/\*([^*\n]+)\*/g, '$1')
        .replace(/_([^_\n]+)_/g, '$1')
        .replace(/~([^~\n]+)~/g, '$1');

        formatado = formatado.replace(/\r?\n+/g, ' ').replace(/\s{2,}/g, ' ').trim();

        return formatado;
    }

  }

  public static informacoesPorStatusContato(statusContato: StatusContatoEnum | undefined, urlImg?: boolean): string {
    switch (statusContato?.toString()) {
      case 'SESSAO_ABERTA_ATENDIMENTO_ABERTO':
        if(urlImg){
          return './assets/icones/icons-contato/purple-max.svg';
        }else{
          return 'Contato com sessão aberta e atendimento aberto';
        }
      case 'SESSAO_ABERTA_SEM_ATENDIMENTO':
        if(urlImg){
          return './assets/icones/icons-contato/blue-good.svg';
        }else{
          return 'Contato com sessão aberta e sem atendimento';
        }
        case 'SESSAO_ABERTA_ATENDIMENTO_FECHADO':
        if(urlImg){
          return './assets/icones/icons-contato/green-good-middle.svg';
        }else{
          return 'Contato com sessão aberta e atendimento fechado';
        }
      case 'SESSAO_FECHADA_ATENDIMENTO_ABERTA':
        if(urlImg){
          return './assets/icones/icons-contato/orange-bad-middle.svg';
        }else{
          return 'Contato com sessão fechada e atendimento aberto';
        }
      case 'SESSAO_FECHADA_ATENDIMENTO_FECHADO':
        if(urlImg){
          return './assets/icones/icons-contato/yellow-bad.svg';
        }else{
          return 'Contato com sessão fechada e atendimento fechado';
        }
      case 'SESSAO_FECHADA_SEM_ATENDIMENTO':
      default:
        if(urlImg){
          return './assets/icones/icons-contato/gray-min.svg';
        }else{
          return 'Contato com sessão fechada e sem atendimento';
        }
    }
  }

  public static getIconeTipoEnvio(tipo: string): string{
    switch (tipo?.toLowerCase()) {
      case 'whatsapp':
        return 'assets/icones/whatsapp-roxo.svg';
      case 'email':
        return 'assets/icones/email-roxo.svg';
      case 'sms':
        return 'assets/icones/sms-roxo.svg';
      default:
        return '';
    }
  }


  public static urlFotoUsuario(grupo: string | number | undefined, uuid: string, extensao: string): string {
    return `${environment.urlRepositorioClaribot}/${grupo}/usuario-img/${uuid}.${extensao}`;
  }

  public static lerStorage(chave: string): string | null {
    try {
      return localStorage.getItem(chave);
    } catch {
      return null;
    }
  }

  public static salvarStorage(chave: string, valor: string): void {
    try {
      localStorage.setItem(chave, valor);
    } catch {
      return;
    }
  }

  public static removerStorage(chave: string): void {
    try {
      localStorage.removeItem(chave);
    } catch {
      return;
    }
  }

  public static lerVelocidadeMidiaSalva(chave: string): number {
    const valor = Number(MethodsUtils.lerStorage(chave));
    return VELOCIDADES_MIDIA.includes(valor) ? valor : 1;
  }

  public static abreviarNumero(valor: number): string {
    const unidade = SUFIXOS_ABREVIACAO_NUMERO.find(item => Math.abs(valor) >= item.divisor);
    if (!unidade) return String(valor);
    const reduzido = Math.abs(valor) / unidade.divisor;
    const casas = reduzido < 100 ? 1 : 0;
    const truncado = Math.floor(reduzido * 10 ** casas) / 10 ** casas;
    return `${valor < 0 ? '-' : ''}${truncado}${unidade.sufixo}`;
  }

  public static inicialDoNome(nome?: string | null): string {
    return (nome ?? '').trim().charAt(0).toUpperCase() || '?';
  }

  public static rotuloLogAtendimento(log: AtendimentoLogModel): string {
    return (log.tipo && ROTULOS_LOG[log.tipo]) || log.tipo || 'Registro';
  }

  public static formatarDuracao(ms: number): string {
    const minutos = Math.max(0, Math.round(ms / MS_POR_MINUTO));
    if (minutos < 1) return 'menos de 1 min';
    const dias = Math.floor(minutos / 1440);
    const horas = Math.floor((minutos % 1440) / 60);
    const min = minutos % 60;
    return [dias ? `${dias}d` : '', horas ? `${horas}h` : '', min ? `${min}min` : ''].filter(Boolean).join(' ');
  }

  public static formatarTelefoneNacional(digitos: string): string {
    if (digitos.length <= 2) return digitos.length ? `(${digitos}` : '';
    const ddd = digitos.slice(0, 2);
    const resto = digitos.slice(2);
    const corte = resto.length > 8 ? 5 : 4;
    if (resto.length <= corte) return `(${ddd}) ${resto}`;
    return `(${ddd}) ${resto.slice(0, corte)}-${resto.slice(corte)}`;
  }

  public static normalizarTexto(texto: string | undefined | null): string {
    return (texto ?? '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  }

  public static extensaoDoArquivo(nomeOuUrl: string): string {
    return (nomeOuUrl || '').split('?')[0].split('.').pop()?.toLowerCase() ?? '';
  }

  public static tipoPreviaMensagem(mensagem: ArquivoMensagem | null | undefined): TipoPreviaMensagemEnum {
    if (!mensagem?.urlImage && !mensagem?.uuidImage) return TipoPreviaMensagemEnum.TEXTO;
    const porTipo = TIPO_PREVIA_POR_TIPO_META[(mensagem.type ?? '').toLowerCase()];
    if (porTipo) return porTipo;
    const extensao = MethodsUtils.extensaoDoArquivo(mensagem.extensao || mensagem.urlImage || '');
    if (extensao === EXTENSAO_FIGURINHA) return TipoPreviaMensagemEnum.FIGURINHA;
    if (EXTENSOES_IMAGEM.includes(extensao)) return TipoPreviaMensagemEnum.FOTO;
    if (EXTENSOES_VIDEO.includes(extensao)) return TipoPreviaMensagemEnum.VIDEO;
    if (EXTENSOES_AUDIO.includes(extensao)) return TipoPreviaMensagemEnum.AUDIO;
    return TipoPreviaMensagemEnum.DOCUMENTO;
  }

  public static ehFigurinha(mensagem: ArquivoMensagem | null | undefined): boolean {
    return MethodsUtils.tipoPreviaMensagem(mensagem) === TipoPreviaMensagemEnum.FIGURINHA;
  }

  public static resumoMensagem(mensagem: (ArquivoMensagem & { mensagem?: string }) | null | undefined): string {
    return mensagem?.mensagem?.trim() || ROTULOS_TIPO_PREVIA[MethodsUtils.tipoPreviaMensagem(mensagem)];
  }

  public static rotuloDia(data: Date): string {
    const hoje = new Date();
    const ontem = new Date();
    ontem.setDate(hoje.getDate() - 1);
    if (data.toDateString() === hoje.toDateString()) return 'Hoje';
    if (data.toDateString() === ontem.toDateString()) return 'Ontem';
    const amanha = new Date();
    amanha.setDate(hoje.getDate() + 1);
    if (data.toDateString() === amanha.toDateString()) return 'Amanhã';
    return data.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  }

  public static transformacaoFlip(origem: DOMRect, destino: DOMRect): string {
    const deslocamentoX = origem.left + origem.width / 2 - (destino.left + destino.width / 2);
    const deslocamentoY = origem.top + origem.height / 2 - (destino.top + destino.height / 2);
    const escala = origem.width / destino.width;
    return `translate(${deslocamentoX}px, ${deslocamentoY}px) scale(${escala})`;
  }

  public static duracaoAnimacao(padraoMs: number): number {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 0 : padraoMs;
  }

  public static rotuloAntecedencia(data: Date, agora: Date): string {
    const minutos = Math.ceil((data.getTime() - agora.getTime()) / MS_POR_MINUTO);
    if (minutos <= 0) return 'agora';
    if (minutos < MINUTOS_POR_HORA) return `em ${minutos} min`;
    return `em ${Math.round(minutos / MINUTOS_POR_HORA)} h`;
  }

  public static formatarTempoMidia(segundos: number): string {
    const total = Math.max(0, Math.floor(segundos || 0));
    const h = Math.floor(total / 3600);
    const m = Math.floor((total % 3600) / 60);
    const s = String(total % 60).padStart(2, '0');
    return h > 0 ? `${h}:${String(m).padStart(2, '0')}:${s}` : `${m}:${s}`;
  }

  public static nomeDoArquivo(url: string): string {
    try {
      return decodeURIComponent(url.split('/').pop()?.split('?')[0] || 'arquivo');
    } catch {
      return 'arquivo';
    }
  }

  public static infoArquivo(extensao: string): InfoArquivo {
    switch ((extensao || '').toLowerCase()) {
      case 'pdf':
        return INFO_ARQUIVO_PDF;
      case 'doc':
      case 'docx':
      case 'txt':
      case 'rtf':
      case 'odt':
        return INFO_ARQUIVO_TEXTO;
      case 'xls':
      case 'xlsx':
      case 'csv':
      case 'ods':
        return INFO_ARQUIVO_PLANILHA;
      case 'ppt':
      case 'pptx':
      case 'odp':
        return INFO_ARQUIVO_APRESENTACAO;
      default:
        return INFO_ARQUIVO_OUTRO;
    }
  }

  public static async baixarArquivo(url: string, nome?: string): Promise<void> {
    const nomeArquivo = nome || MethodsUtils.nomeDoArquivo(url);
    try {
      const resposta = await fetch(url, { mode: 'cors', credentials: 'omit' });
      if (!resposta.ok) throw new Error(`HTTP ${resposta.status}`);
      const blob = await resposta.blob();
      const urlLocal = URL.createObjectURL(blob);
      MethodsUtils.clicarLinkDownload(urlLocal, nomeArquivo);
      setTimeout(() => URL.revokeObjectURL(urlLocal), 10_000);
    } catch {
      MethodsUtils.clicarLinkDownload(url, nomeArquivo, true);
    }
  }

  private static clicarLinkDownload(href: string, nome: string, novaGuia = false): void {
    const a = document.createElement('a');
    a.href = href;
    a.download = nome;
    if (novaGuia) {
      a.target = '_blank';
      a.rel = 'noopener';
    }
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  }

  public static configPainelLateralChat<D>(data: D, larguraDesktop = '420px'): MatDialogConfig<D> {
    if (window.innerWidth < 768) {
      return {
        data,
        width: '100vw',
        maxWidth: '100vw',
        height: '92dvh',
        maxHeight: '92dvh',
        position: { bottom: '0' },
        panelClass: ['slide-modal-baixo', CLASSE_FONTE_CHAT],
        autoFocus: false
      };
    }
    return {
      data,
      width: larguraDesktop,
      maxWidth: '100vw',
      height: '100dvh',
      maxHeight: '100dvh',
      position: { top: '0', right: '0' },
      panelClass: ['slide-modal', CLASSE_FONTE_CHAT],
      autoFocus: false
    };
  }

}
